// extracted by mini-css-extract-plugin
module.exports = {"iconLeft":"system_button-module__iconLeft--3178D","iconRight":"system_button-module__iconRight--IQJZq"};